import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import * as s from "./styles/globalStyles";
import styled from "styled-components";

const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;

export const StyledButton = styled.button`
  padding: 10px;

  border: none;
  background-color: var(--secondary);

  color: var(--secondary-text);
  width: 100px;
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const StyledSocialButton = styled.button`
  padding: 10px;

  border: none;
  background-color: var(--secondary);

  color: var(--secondary-text);
  width: 60px;
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const StyledRoundButton = styled.button`
  padding: 10px;

  border: none;
  background-color: var(--primary);

  color: var(--primary-text);
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretched;
  align-items: stretched;
  width: 100%;
  @media (min-width: 767px) {
    flex-direction: row;
  }
`;

export const StyledLogo = styled.img`
  width: 400px;
  @media (min-width: 767px) {
    width: 600px;
  }
  transition: width 0.5s;
  transition: height 0.5s;
`;

export const StyledSocial = styled.img`
  width: 40px;
  @media (min-width: 767px) {
    width: 40px;
  }
  transition: width 0.5s;
  transition: height 0.5s;
`;

export const StyledImg = styled.img`
  box-shadow: 0px 5px 11px 2px rgba(0, 0, 0, 0.7);
  border: 4px dashed var(--secondary);
  background-color: var(--accent);
  border-radius: 100%;
  width: 200px;
  @media (min-width: 900px) {
    width: 250px;
  }
  @media (min-width: 1000px) {
    width: 300px;
  }
  transition: width 0.5s;
`;

export const StyledLink = styled.a`
  color: var(--secondary);
  text-decoration: none;
`;

function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [claimingNft, setClaimingNft] = useState(false);
  const [feedback, setFeedback] = useState(`Read Roadmap, Choose Wisely`);
  const [mintAmount, setMintAmount] = useState(1);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });

  const claimNFTs = () => {
    let cost = CONFIG.WEI_COST;
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalCostWei = String(cost * mintAmount);
    let totalGasLimit = String(gasLimit * mintAmount);
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .mint(blockchain.account,mintAmount)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `WOW, the ${CONFIG.NFT_NAME} is yours! go visit Opensea.io to view it.`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = () => {
    let newMintAmount = mintAmount + 1;
    if (newMintAmount > 88) {
      newMintAmount = 88;
    }
    setMintAmount(newMintAmount);
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  return (
    <s.Screen>
      <s.Container
        flex={1}
        ai={"center"}
        style={{ padding: 24, backgroundColor: "var(--primary)" }}
        image={CONFIG.SHOW_BACKGROUND ? "/config/images/bg.png" : null}
      >
        <StyledLogo alt={"logo"} src={"/config/images/logo.png"} />

        <ResponsiveWrapper flex={1} style={{ padding: 24 }} test>

          <s.SpacerLarge />
          <s.Container
            flex={2}
            jc={"center"}
            ai={"center"}
            style={{
              backgroundColor:"rgba(50, 50, 50, 0.8)",
              padding: 24,
              borderRadius: 0,
              border: "15px dashed var(--secondary)",
              boxShadow: "0px 5px 11px 2px rgba(0,0,0,0.7)",
            }}
          >
            <s.TextTitle
              style={{
                textAlign: "center",
                fontSize: 50,
                fontWeight: "bold",
                color: "var(--accent-text)",
              }}
            >
            {Number(data.totalSupply) >= 100 ? (
              <>
              {data.totalSupply} / {CONFIG.MAX_SUPPLY}
              </>
            ) : (
              <>
              ? / {CONFIG.MAX_SUPPLY}
              </>
            )}

            </s.TextTitle>
      
            <s.SpacerSmall />
            {Number(data.totalSupply) >= CONFIG.MAX_SUPPLY ? (
              <>
                <s.TextTitle
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  The sale has ended.
                </s.TextTitle>
                <s.TextDescription
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  You can still find {CONFIG.NFT_NAME} on
                </s.TextDescription>
                <s.SpacerSmall />
                <StyledLink target={"_blank"} href={CONFIG.MARKETPLACE_LINK}>
                  {CONFIG.MARKETPLACE}
                </StyledLink>
              </>
            ) : (
              <>
                <s.TextTitle
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  ***WHITELIST ONLY UNTIL 10 PM EST*** <s.SpacerSmall />
                  {CONFIG.DISPLAY_COST}{" "}
                  {CONFIG.NETWORK.SYMBOL}{" "} per mint
                </s.TextTitle>
                <s.SpacerXSmall />
                <s.TextDescription
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  Let’s get quackin’! 🦆
                </s.TextDescription>
                <s.SpacerSmall />
                {blockchain.account === "" ||
                blockchain.smartContract === null ? (
                  <s.Container ai={"center"} jc={"center"}>
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      Connect to the {CONFIG.NETWORK.NAME} network
                    </s.TextDescription>
                    <s.SpacerSmall />
                    <StyledButton
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(connect());
                        getData();
                      }}
                    >
                      CONNECT
                    </StyledButton>
                    {blockchain.errorMsg !== "" ? (
                      <>
                        <s.SpacerSmall />
                        <s.TextDescription
                          style={{
                            textAlign: "center",
                            color: "var(--accent-text)",
                          }}
                        >
                          {blockchain.errorMsg}
                        </s.TextDescription>
                      </>
                    ) : null}
                  </s.Container>
                ) : (
                  <>
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      {feedback}
                    </s.TextDescription>
                    <s.SpacerMedium />
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>
                      <StyledRoundButton
                        style={{ lineHeight: 0.4 }}
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          decrementMintAmount();
                        }}
                      >
                        -
                      </StyledRoundButton>
                      <s.SpacerMedium />
                      <s.TextDescription
                        style={{
                          textAlign: "center",
                          color: "var(--accent-text)",
                        }}
                      >
                        {mintAmount}
                      </s.TextDescription>
                      <s.SpacerMedium />
                      <StyledRoundButton
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          incrementMintAmount();
                        }}
                      >
                        +
                      </StyledRoundButton>
                    </s.Container>
                    <s.SpacerSmall />
                    <s.Container ai={"center"} jc={"center"} fd={"row"}>
                      <StyledButton
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          claimNFTs();
                          getData();
                        }}
                      >
                        {claimingNft ? "MINTING..." : "MINT"}
                      </StyledButton>
                    </s.Container>
                  </>
                )}
              </>
            )}
            <s.SpacerMedium />

            <s.TextDescription
            style={{
              textAlign: "center",
              color: "var(--accent-text)",
            }}
             >
             
            <StyledLink target={"_blank"} href="https://twitter.com/duckandgoosenft">
            {"  "} <StyledSocial alt={"Our Twitter "} src={"/config/images/Twitter_White.png"} />
            </StyledLink>
          
            
            <StyledLink target={"_blank"} href="https://opensea.io/collection/duck-duck-goose-game">
            {"  "} <StyledSocial alt={"Our Opensea "} src={"/config/images/Opensea_White.png"} />
            </StyledLink>

          

            <StyledLink target={"_blank"} href="https://discord.com/invite/z37fpg2arB">
            {"  "} <StyledSocial alt={"Our Discord "} src={"/config/images/Discord_White.png"} />
            </StyledLink>


            
          </s.TextDescription>


          </s.Container>
          <s.SpacerLarge />




        </ResponsiveWrapper>










<ResponsiveWrapper flex={1} style={{ padding: 24 }} test>

          <s.SpacerLarge />
          <s.Container
            flex={2}
            jc={"center"}
            ai={"center"}
            style={{
              backgroundColor:"rgba(50, 50, 50, 0.8)",
              padding: 24,
              borderRadius: 0,
              border: "15px dashed var(--secondary)",
              boxShadow: "0px 5px 11px 2px rgba(0,0,0,0.7)",
            }}
          >
            <s.TextTitle
              style={{
                textAlign: "center",
                fontSize: 50,
                fontWeight: "bold",
                color: "var(--accent-text)",
              }}
            >
              Roadmap
            </s.TextTitle>
            
            <s.SpacerSmall />
            
            <s.Container jc={"center"} ai={"center"} style={{ width: "70%" }}>


                <s.SpacerSmall />

              <s.TextDescription
                style={{
                textAlign: "center",
                color: "var(--accent-text)",
              }}
              >
                She says the metaverse $LAKE changed me. She has no idea how much. There are many more geese🦢 out there, those who rule through intimidation and fear. Every last one of them will wish I had died on that $LAKE.  
              </s.TextDescription>
              <s.SpacerSmall />
              <s.TextDescription
                style={{
                textAlign: "center",
                color: "var(--accent-text)",
              }}
              >
                Thousands of Ducks and Geese compete to find a place to live on a $LAKE in the metaverse. Generations ago, both species lived happily on the $LAKE. Since The Great Accident of 1888, peace is no longer an option. The stakes are high, as without $LAKE, they will perish.
              </s.TextDescription>
              <s.SpacerSmall />
              <s.TextDescription
                style={{
                textAlign: "center",
                color: "var(--accent-text)",
              }}
              >
                In the race between duck and goose, the duck mostly wins...🦆 but only when well surrounded. They huddle together in the Lake regularly, occupying plots of water which allows their owners to farm $LAKE. With more $LAKE, the ducks thrive and their owners can purchase more Ducks! But, on the other side of the Lake lurk dangers the Ducks are terrified of... The Geese.
              </s.TextDescription>
              <s.SpacerSmall />
              <s.TextDescription
                style={{
                textAlign: "center",
                color: "var(--accent-text)",
              }}
              >
                The Geese are ruthless and will kill for a spot in the $LAKE.  🦢  They will hunt down Ducks and get their precious $LAKE by all means necessary. They'll sneak up on a lone duck, and before you know it... the Duck is gone. Based on a deal struck by the current generation's ancestors, Ducks will leave a portion of all $LAKE to the Geese. In return, the Geese play nice.
              </s.TextDescription>
              <s.SpacerSmall />
              <s.TextDescription
                style={{
                textAlign: "center",
                color: "var(--accent-text)",
              }}
              >
                When a Duck leaves the $LAKE or new Ducks are born… The Geese don’t hold back.
              </s.TextDescription>
<s.SpacerSmall />
              <s.TextDescription
                style={{
                textAlign: "center",
                color: "var(--accent-text)",
              }}
              >
                _________________________________________
              </s.TextDescription>
<s.SpacerSmall />
              <s.TextSubTitle
                style={{
                textAlign: "center",
                fontSize: 40,
                fontWeight: "bold",
                color: "var(--accent-text)",
                }}
              >
                DUCKS 🦆
              </s.TextSubTitle>
<s.SpacerSmall />              
              <s.TextDescription
                style={{
                textAlign: "center",
                color: "var(--accent-text)",
              }}
              >

 
You have a 90% chance of minting a Duck, each with unique traits. 
<s.SpacerSmall />  
Enter Lake (Stake) <s.SpacerSmall />   Accumulate 10,000 $LAKE / day (prorated to the second)
<s.SpacerSmall />  
Claim $LAKE    <s.SpacerSmall /> Receive 80% of $LAKE accumulated on your Duck    Geese take a guaranteed 20% tax on sheared $LAKE in return for not attacking the ducks. Taxed $LAKE is split among all the Geese currently staked in the Lake.
<s.SpacerSmall />  
Leave Lake (Unstake)  <s.SpacerSmall />  Ducks are removed from the Lake and all $LAKE is claimed. Can only be done if the duck has accumulated 2 days worth of $LAKE to keep it safe.    50% chance of ALL of your accumulated $LAKE being stolen by Geese. Stolen $LAKE is split among all the Geese currently staked in the Lake.
<s.SpacerSmall />  
***NEW!*** Stack Ducks (Stack)  <s.SpacerSmall />   When multiple Ducks enter the Lake (Stake), $LAKE rewards are multiplied based on the amount of Ducks staked. Example: 1 Duck Staked = 1x (10,000 $LAKE/Day), 2 Ducks Staked = 1.10x (22,000 $LAKE/Day), 3 Ducks Staked = 1.20x (36,000 $LAKE/Day), 5 Ducks Staked = 1.40x (70,000 $LAKE/Day), 10 Ducks Staked = 1.50x (150,000 $LAKE/Day), 20 Ducks Staked = 2.00x (400,000 $LAKE/Day). Every Duck past 20 Ducks staked will bring the multiplier up by 0.02x / Day.
<s.SpacerSmall />  
***NEW!*** Kidnap   <s.SpacerSmall />   When 5 Ducks come together, they have the capacity to fight back and kidnap a Goose. Remember, when ducks stay together, they are strong. When you have 5 Stacked Ducks, you have a 2% chance/day staked to STEAL A GOOSE. 

              </s.TextDescription>
<s.SpacerSmall />
              <s.TextSubTitle
                style={{
                textAlign: "center",
                fontSize: 40,
                fontWeight: "bold",
                color: "var(--accent-text)",
                }}
              >
                GEESE 🦢
              </s.TextSubTitle>
<s.SpacerSmall />              
              <s.TextDescription
                style={{
                textAlign: "center",
                color: "var(--accent-text)",
              }}
              >


 
You have a 10% chance of minting a Goose, each with unique traits. 
ONLY Staked Geese are able to steal ducks or earn $LAKE tax. 
<s.SpacerSmall />
Stake Goose  <s.SpacerSmall />  Earn your share of the 20% tax of all $LAKE generated by Ducks in the Lake. <s.SpacerSmall />
Claim $LAKE   <s.SpacerSmall /> Receive all $LAKE taxes accrued for the staked Goose. <s.SpacerSmall />
Unstake Goose  <s.SpacerSmall /> Receive all $LAKE taxes accrued for the staked Goose. <s.SpacerSmall />

When staked, geese have a small chance of being stolen by stacks of 5 ducks or more. Be careful! The only way to fight back a group of ducks is for the geese to be in numbers too! When you have >1 Goose Staked, your Geese CAN FIGHT BACK and will not be stolen by stacks of ducks. 
          </s.TextDescription>






          


            </s.Container>


            <s.SpacerMedium />
          </s.Container>
          <s.SpacerLarge />

        </ResponsiveWrapper>






<ResponsiveWrapper flex={1} style={{ padding: 24 }} test>

          <s.SpacerLarge />
          <s.Container
            flex={2}
            jc={"center"}
            ai={"center"}
            style={{
              backgroundColor:"rgba(50, 50, 50, 0.8)",
              padding: 24,
              borderRadius: 0,
              border: "15px dashed var(--secondary)",
              boxShadow: "0px 5px 11px 2px rgba(0,0,0,0.7)",
            }}
          >
            <s.TextTitle
              style={{
                textAlign: "center",
                fontSize: 50,
                fontWeight: "bold",
                color: "var(--accent-text)",
              }}
            >
              Game Status :
            </s.TextTitle>
            
            <s.SpacerSmall />
            
<s.Container jc={"center"} ai={"center"} style={{ width: "70%" }}>

          <s.TextSubTitle
                style={{
                textAlign: "center",
                fontSize: 40,
                fontWeight: "bold",
                color: "var(--accent-text)",
                }}
              >
               Revealing Soon
              </s.TextSubTitle>


          <s.SpacerSmall />
          


</s.Container>


            <s.SpacerMedium />
          </s.Container>
          <s.SpacerLarge />

        </ResponsiveWrapper>











        
          

      </s.Container>
    </s.Screen>
  );
}

export default App;
